module.exports = __webpack_public_path__ + "static/media/oil-change-red.d04d502e.svg";